import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionVenue } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-cerfa-information-verification',
  templateUrl: 'cerfa-information-verification.component.html',
  styleUrls: ['./cerfa-information-verification.component.less', '../../../shared/common.less'],
})

export class CerfaInformationVerificationComponent implements OnInit {
  @Input() venue: ElectionVenue;
  @Output() venueChange = new EventEmitter<ElectionVenue>();
  @Output() validated = new EventEmitter<boolean>();
  @Output() editRequested = new EventEmitter<void>();
  isValidated: boolean = false;
  isExpanded: boolean = true;
  needPap: boolean = undefined;

  constructor() {}
  
  onVenueChange() {
    this.venueChange.emit(this.venue);
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  onEdit() {
    this.editRequested.emit();
  }

  onValidate() {
    this.isExpanded = false;
    this.isValidated = true;
    this.validated.emit(true);
  }



  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  
  ngOnInit(): void {
  }
}
